import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import {
  Card,
  Stack,
  Typography,
  TextField,
  Button,
  Checkbox,
  IconButton,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Chip
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CustomFilter from 'src/components/filter/CustomFilter';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';
import MopedIcon from '@mui/icons-material/Moped';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { tokenService } from 'src/services';

// ----------------------------------------------------------------------

export default function CargoCourierAVMPage() {
  // Sample data matching the screenshot exactly
  const initialRequests = [
    {
      id: 1,
      mallName: "Galataport",
      storeName: "Karaca",
      requester: "Ayşe Yılmaz",
      type: "Kargo",
      source: "Kargolst",
      requestNo: "1234567890",
      phone: "5531234515",
      senderType: "Bireysel",
      category: "Kitap",
      date: "15.05.2025 13:44",
      quantity: 1,
      status: "Aktif",
      state: "Yolda"
    },
    {
      id: 2,
      mallName: "İstinyepark İzmir",
      storeName: "H&M",
      requester: "Mehmet Güneş",
      type: "Kurye",
      source: "Vigo",
      requestNo: "1234567890",
      phone: "5531234570",
      senderType: "Bireysel",
      category: "Kıyafet",
      date: "15.05.2025 13:44",
      quantity: 2,
      status: "Teslim Edildi",
      state: "Kurye Zimmetinde"
    },
    {
      id: 3,
      mallName: "İstinyepark İzmir",
      storeName: "Nike",
      requester: "Caner Akın",
      type: "Kurye",
      source: "Vigo",
      requestNo: "12345678",
      phone: "5531234583",
      senderType: "Bireysel",
      category: "Yiyecek",
      date: "15.05.2025 13:44",
      quantity: 1,
      status: "İptal",
      state: "Mal Kabule Dönüyor"
    },
    {
      id: 4,
      mallName: "Galataport",
      storeName: "Louis Vuitton",
      requester: "Tolga Naz",
      type: "Kargo",
      source: "Kargolst",
      requestNo: "1234567890",
      phone: "5531234555",
      senderType: "Kurumsal",
      category: "Teknoloji",
      date: "15.05.2025 13:44",
      quantity: 3,
      status: "Aktif",
      state: "Yolda"
    },
    {
      id: 5,
      mallName: "Galataport",
      storeName: "Dior",
      requester: "Oya Deniz",
      type: "Kargo",
      source: "Kargolst",
      requestNo: "1234567890",
      phone: "5531234594",
      senderType: "Bireysel",
      category: "Teknoloji",
      date: "15.05.2025 13:44",
      quantity: 2,
      status: "Teslim Edildi",
      state: "Kurye Zimmetinde"
    },
    {
      id: 6,
      mallName: "Galataport",
      storeName: "Louis Vuitton",
      requester: "Rıza Mert",
      type: "Kargo",
      source: "Kargolst",
      requestNo: "1234567890",
      phone: "5531234522",
      senderType: "Kurumsal",
      category: "Kitap",
      date: "15.05.2025 13:44",
      quantity: 2,
      status: "Aktif",
      state: "Kurye Zimmetinde"
    },
    {
      id: 7,
      mallName: "Galataport",
      storeName: "Louis Vuitton",
      requester: "Ayşe Yılmaz",
      type: "Kargo",
      source: "Kargolst",
      requestNo: "1234567890",
      phone: "5531234555",
      senderType: "Bireysel",
      category: "Kitap",
      date: "15.05.2025 13:44",
      quantity: 1,
      status: "İptal",
      state: "Deske Dönüyor"
    }
  ];

  const columns = [
    {
      id: 'storeName',
      label: 'MAĞAZA ADI',
      align: 'left',
      width: '18%',
      minWidth: 150
    },
    {
      id: 'requester',
      label: 'TALEP EDEN KİŞİ',
      align: 'left',
      width: '15%',
      minWidth: 130
    },
    {
      id: 'source',
      label: 'TALEP FİRMASI',
      align: 'left',
      width: '10%',
      minWidth: 120
    },
    {
      id: 'requestNo',
      label: 'TALEP NO',
      align: 'left',
      width: '10%',
      minWidth: 100
    },
    {
      id: 'phone',
      label: 'ALICI TEL NO',
      align: 'left',
      width: '10%',
      minWidth: 110
    },
    {
      id: 'senderType',
      label: 'GÖNDERİ TİPİ',
      align: 'left',
      width: '8%',
      minWidth: 100
    },
    {
      id: 'category',
      label: 'ÜRÜN KATEGORİSİ',
      align: 'left',
      width: '10%',
      minWidth: 120
    },
    {
      id: 'date',
      label: 'OLUŞTURMA TARİHİ',
      align: 'left',
      width: '12%',
      minWidth: 150
    },
    {
      id: 'quantity',
      label: 'ADET',
      align: 'left',
      width: '5%',
      minWidth: 60
    },
    {
      id: 'status',
      label: 'DURUMU',
      align: 'left',
      width: '8%',
      minWidth: 90
    },
    {
      id: 'state',
      label: 'STATÜ',
      align: 'left',
      width: '12%',
      minWidth: 130
    },
    {
      id: 'document',
      label: '',
      align: 'center',
      width: '5%',
      minWidth: 40,
      format: () => (
        <IconButton size="small">
          <DescriptionIcon />
        </IconButton>
      )
    },
    {
      id: 'edit',
      label: '',
      align: 'center',
      width: '5%',
      minWidth: 40,
      format: (value, row) => (
        <IconButton size="small" onClick={() => handleOpenEditModal(row)}>
          <EditIcon />
        </IconButton>
      )
    }
  ];
  const [filters, setFilters] = useState({
    searchText: '',
    requester: '',
    type: '',
    source: '',
    requestNo: '',
    phone: '',
    senderType: '',
    category: '',
    status: '',
    state: '',
  });
  const [requests, setRequests] = useState(initialRequests);
  const [filteredRequests, setFilteredRequests] = useState(initialRequests);
  const [filterModal, setFilterModal] = useState(false);
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('date');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState(0);
  const [formType, setFormType] = useState('');
  const [formData, setFormData] = useState({
    company: '',
    senderName: '',
    senderSurname: '',
    senderPhone: '',
    senderEmail: '',
    senderTCKN: '',
    senderType: '',
    category: '',
    quantity: 1,
    length: '',
    width: '',
    height: '',
    receiverCity: '',
    receiverTown: '',
    receiverName: '',
    receiverPhone: '',
    receiverAddress: '',
    status: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [token, setToken] = useState(null);
  const [cities, setCities] = useState([]);
  const [towns, setTowns] = useState([]);
  const categories = ['Kitap', 'Kıyafet', 'Yiyecek', 'Teknoloji'];
  const [successData, setSuccessData] = useState(null);
  const [editingRequest, setEditingRequest] = useState(null);
  const [modalMode, setModalMode] = useState('create'); // 'create' or 'edit'

  // Firma seçenekleri
  const kargoFirms = [{ label: 'Kargoist', value: 'Kargolst' }];
  const kuryeFirms = [{ label: 'Vigo', value: 'Vigo' }];
  const allFirms = [...kargoFirms, ...kuryeFirms]; // Tüm firmaları birleştirdik

  // Durum seçenekleri
  const statusOptions = ['Aktif', 'Teslim Edildi', 'İptal'];

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedRequests = [...filteredRequests].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[orderBy] > b[orderBy]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingRequest(null);
    setFormErrors({});
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters(prevFilters => {
      const newFilters = { ...prevFilters, [name]: value };
      if (name === 'searchText') {
        if (value === '') {
          setFilteredRequests(requests);
        } else {
          const filteredRequests = requests.filter(request => {
            const searchMatch = value === '' || String(request.requestNo).toLowerCase().includes(value.toLowerCase());
            const filterMatch = Object.keys(newFilters).every(key => {
              if (key === 'searchText') return true;
              if (!newFilters[key]) return true;
              return String(request[key]).toLowerCase().includes(newFilters[key].toLowerCase());
            });
            return searchMatch && filterMatch;
          });
          setFilteredRequests(filteredRequests);
        }
      }
      return newFilters;
    });
  };

  const applyFilters = () => {
    const filteredRequests = requests.filter(request => {
      const searchMatch = filters.searchText === '' || String(request.requestNo).toLowerCase().includes(filters.searchText.toLowerCase());
      const filterMatch = Object.keys(filters).every(key => {
        if (key === 'searchText') return true;
        if (!filters[key]) return true;
        return String(request[key]).toLowerCase().includes(filters[key].toLowerCase());
      });
      return searchMatch && filterMatch;
    });
    setFilteredRequests(filteredRequests);
    setFilterModal(false);
  };

  const clearFilters = () => {
    setFilters({
      searchText: '',
      requester: '',
      type: '',
      source: '',
      requestNo: '',
      phone: '',
      senderType: '',
      category: '',
      status: '',
      state: '',
    });
    setFilteredRequests(requests);
    setFilterModal(false);
  };

  const handleOpenFilterModal = () => setFilterModal(true);
  const handleCloseFilterModal = () => setFilterModal(false);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await fetch(`https://prod.easypointapi.com/api/get-token?`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            key: 'wHjOKqH25WwOEeHphyGR',
            secret: '37m2LWciLhboNNFA6UkQ',
          })
        });
        const data = await res.json();
        setToken(data.result.token);
      } catch {
        setToken(null);
      }
    };
    fetchToken();
  }, []);

  useEffect(() => {
    if (!token) return;
    const fetchCities = async () => {
      const res = await fetch('https://prod.easypointapi.com/api/flow/get-cities', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setCities(data.result || []);
    };
    fetchCities();
    console.log("Requests : ",requests)
  }, [token, requests]);

  useEffect(() => {
    if (!token || !formData.receiverCity) return;
    const selectedCity = cities.find(c => c.name === formData.receiverCity);
    if (!selectedCity) return;
    const fetchTowns = async () => {
      const res = await fetch('https://prod.easypointapi.com/api/flow/get-towns', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ cityCode: selectedCity.code })
      });
      const data = await res.json();
      setTowns(data.result || []);
    };
    fetchTowns();
  }, [token, formData.receiverCity]);

  const handleUpdateRequest = () => {
    const errors = {};
    if (!formData.senderName) errors.senderName = 'Zorunlu alan';
    if (!formData.company) errors.company = 'Zorunlu alan';
    if (!formData.receiverPhone || !/^\d{10,11}$/.test(formData.receiverPhone)) errors.receiverPhone = 'Geçerli telefon girin';
    if (!formData.senderType) errors.senderType = 'Zorunlu alan';
    if (!formData.category) errors.category = 'Zorunlu alan';
    if (!formData.quantity || formData.quantity < 1) errors.quantity = 'En az 1 olmalı';
    if (!formData.status) errors.status = 'Zorunlu alan';

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setRequests(requests.map(req =>
      req.id === editingRequest.id ? {
        ...req,
        requester: formData.senderName,
        source: formData.company,
        phone: formData.receiverPhone,
        senderType: formData.senderType,
        category: formData.category,
        quantity: formData.quantity,
        status: formData.status,
      } : req
    ));

    const updatedRequests = requests.map(req =>
      req.id === editingRequest.id ? {
        ...req,
        requester: formData.senderName,
        source: formData.company,
        phone: formData.receiverPhone,
        senderType: formData.senderType,
        category: formData.category,
        quantity: formData.quantity,
        status: formData.status,
      } : req
    );
    setRequests(updatedRequests);

    const filteredAfterUpdate = updatedRequests.filter(request => {
      const searchMatch = filters.searchText === '' || String(request.requestNo).toLowerCase().includes(filters.searchText.toLowerCase());
      const filterMatch = Object.keys(filters).every(key => {
        if (key === 'searchText') return true;
        if (!filters[key]) return true;

        if (key === 'requester' || key === 'source' || key === 'phone' || key === 'senderType' || key === 'category' || key === 'status' || key === 'state' || key === 'requestNo') {
          return String(request[key]).toLowerCase().includes(filters[key].toLowerCase());
        }

        return String(request[key]).toLowerCase().includes(filters[key].toLowerCase());
      });
      return searchMatch && filterMatch;
    });
    setFilteredRequests(filteredAfterUpdate);
    setModalOpen(false);
  };

  const handleOpenEditModal = (request) => {
    setEditingRequest(request);
    setFormData({
      company: request.source,
      senderName: request.requester,
      senderSurname: '',
      senderPhone: '',
      senderEmail: '',
      senderTCKN: '',
      senderType: request.senderType,
      category: request.category,
      quantity: request.quantity,
      length: '',
      width: '',
      height: '',
      receiverCity: '',
      receiverTown: '',
      receiverName: '',
      receiverPhone: request.phone,
      receiverAddress: '',
      status: request.status,
    });
    setFormErrors({});
    setModalOpen(true);
  };

  const renderForm = () => (
    <Box p={3} sx={{ minWidth: 600 }}>
      <Typography variant="h6" mb={2}>Kurye - Kargo</Typography>

      {/* Talep Düzenleme Bilgileri */}
      <Typography variant="subtitle2" mt={2} mb={3} color='rgba(186, 186, 186, 1)' >Talep Düzenleme</Typography>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          label="Talep Eden Kişi"
          value={formData.senderName}
          onChange={e => setFormData(f => ({ ...f, senderName: e.target.value }))}
          fullWidth
          error={!!formErrors.senderName}
          helperText={formErrors.senderName}
        />

        <FormControl fullWidth error={!!formErrors.company}>
          <InputLabel>Talep Firması</InputLabel>
          <Select
            value={formData.company}
            label="Talep Firması"
            onChange={e => setFormData(f => ({ ...f, company: e.target.value }))}
          >
            {allFirms.map(opt => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
          </Select>
          {formErrors.company && <Typography color="error" fontSize={12}>{formErrors.company}</Typography>}
        </FormControl>
      </Stack>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField label="Talep No" value={editingRequest?.requestNo || ''} disabled fullWidth />
        <TextField label="Alıcı Tel No" value={formData.receiverPhone} onChange={e => setFormData(f => ({ ...f, receiverPhone: e.target.value.replace(/\D/g, '') }))} error={!!formErrors.receiverPhone} helperText={formErrors.receiverPhone} fullWidth />
      </Stack>

      {/* Gönderi Düzenleme Bilgileri */}
      <Typography variant="subtitle2" mt={2} mb={3} color='rgba(186, 186, 186, 1)'>Gönderi Düzenleme</Typography>
      <Stack direction="row" spacing={2} mb={2}>
        <FormControl fullWidth error={!!formErrors.senderType}>
          <InputLabel>Gönderi Tipi</InputLabel>
          <Select
            value={formData.senderType}
            label="Gönderi Tipi"
            onChange={e => setFormData(f => ({ ...f, senderType: e.target.value }))}
          >
            <MenuItem value="Bireysel">Bireysel</MenuItem>
            <MenuItem value="Kurumsal">Kurumsal</MenuItem>
          </Select>
          {formErrors.senderType && <Typography color="error" fontSize={12}>{formErrors.senderType}</Typography>}
        </FormControl>
        <FormControl fullWidth error={!!formErrors.category}>
          <InputLabel>Ürün Kategorisi</InputLabel>
          <Select
            value={formData.category}
            label="Ürün Kategorisi"
            onChange={e => setFormData(f => ({ ...f, category: e.target.value }))}
          >
            {categories.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
          </Select>
          {formErrors.category && <Typography color="error" fontSize={12}>{formErrors.category}</Typography>}
        </FormControl>
      </Stack>

      {/* Paket Bilgisi */}
      <Typography variant="subtitle2" mt={2} mb={3} color='rgba(186, 186, 186, 1)'>Paket Bilgisi</Typography>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField label="Paket Adedi" type="number" inputProps={{ min: 1 }} value={formData.quantity} onChange={e => setFormData(f => ({ ...f, quantity: Math.max(1, Number(e.target.value)) }))} error={!!formErrors.quantity} helperText={formErrors.quantity} fullWidth />
        <FormControl fullWidth error={!!formErrors.status}>
          <InputLabel>Durumu</InputLabel>
          <Select
            value={formData.status}
            label="Durumu"
            onChange={e => setFormData(f => ({ ...f, status: e.target.value }))}
          >
            {statusOptions.map(status => <MenuItem key={status} value={status}>{status}</MenuItem>)}
          </Select>
          {formErrors.status && <Typography color="error" fontSize={12}>{formErrors.status}</Typography>}
        </FormControl>
      </Stack>

      {/* Güncelle Butonu */}
      <Button
        fullWidth
        variant="contained"
        sx={{ background: 'rgba(32, 101, 209, 1)', color: '#fff', fontWeight: 500, fontSize: 16, borderRadius: 2, mt: 2 }}
        onClick={handleUpdateRequest}
      >
        Güncelle
      </Button>
    </Box>
  );

  // Status badge renk ve stil fonksiyonu
  function getStatusBadgeStyle(status) {
    if (status === 'Aktif') {
      return {
        borderColor: 'rgba(187, 247, 208, 1)',
        textColor: 'rgba(21, 128, 61, 1)',
        bg: 'rgba(240, 253, 244, 1)'
      };
    }
    if (status === "Teslim Edildi") {
      return {
        borderColor: 'rgba(187, 247, 208, 1)',
        textColor: 'rgba(21, 128, 61, 1)',
        bg: 'rgba(240, 253, 244, 1)',
        minWidth: '90px'
      };
    }
    if (status === 'İptal') {
      return {
        borderColor: 'rgba(255, 59, 48, 0.3)',
        textColor: '#B71C1C',
        bg: 'rgba(255, 59, 48, 0.08)'
      };
    }
    // Diğer durumlar için default
    return {
      borderColor: '#E0E0E0',
      textColor: '#333',
      bg: '#fff'
    };
  }

  const StatusBadge = ({ status }) => {
    const { borderColor, textColor, bg, minWidth } = getStatusBadgeStyle(status);
    return (
      <Box
        sx={{
          minWidth: minWidth,
          width: 'fit-content',
          display: 'inline-block',
          px: 1,
          py: 0.25,
          borderRadius: '16px',
          border: `1px solid ${borderColor}`,
          color: textColor,
          background: bg,
          fontWeight: 500,
          fontSize: 12,
          textAlign: 'center',
        }}
      >
        {status}
      </Box>
    );
  };

  return (
    <>
      <Helmet>
        <title>Kurye - Kargo Yönetici</title>
      </Helmet>

      <Stack style={{ padding: '25px' }}>
        {/* Main Title */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
          borderBottom='1px solid rgba(235, 235, 235, 1)'
          paddingBottom={1.5}
        >
          <Typography variant="h4" sx={{fontSize: '16px !important'}}>Kurye - Kargo</Typography>
        </Stack>

        <Box sx={{
          backgroundColor: 'white',
          pt: 2,
          boxShadow : 1,
          br: 1,
          mt: 3,
        }}>
          <Box sx={{
            px: 2,
          }}>
            {/* Section Title */}
            <Typography variant="h5" gutterBottom mb={2} sx={{
              fontSize : '14px !important'
            }}>
              Kargo - Kurye Talep Listesi
            </Typography>

            {/* Search and Filter Row */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Box display="flex" alignItems="center" flexGrow={1} maxWidth="400px">
                <TextField
                  fullWidth
                  placeholder="Talep no ara..."
                  variant="outlined"
                  size="small"
                  name="searchText"
                  value={filters.searchText}
                  onChange={handleFilterChange}
                  InputProps={{
                    startAdornment: (
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                    }
                  }}
                />
              </Box>
              <Button
                variant="outlined"
                startIcon={<FilterAltIcon />}
                onClick={handleOpenFilterModal}
                sx={{
                  borderColor: 'rgba(32, 101, 209, 1)',
                  color: 'rgba(32, 101, 209, 1)',
                  '&:hover': {
                    borderColor: '#1565c0',
                    backgroundColor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Filtrele
              </Button>
            </Box>
          </Box>
          {/* Table */}
          <Card sx={{ overflow: 'auto' }}>
            <Table sx={{ minWidth: 1200 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      sx={{
                        width: column.width,
                        minWidth: column.minWidth || column.width,
                        fontWeight: 'bold',
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        fontSize: '12px',
                        padding: '8px 12px',
                        whiteSpace: 'nowrap'
                      }}
                      sortDirection={orderBy === column.id ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : 'asc'}
                        onClick={() => handleRequestSort(column.id)}
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedRequests
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      sx={{
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                      }}
                    >
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          sx={{
                            borderBottom: '1px solid rgba(224, 224, 224, 1)',
                            padding: '12px 16px'
                          }}
                        >
                          {column.id === 'status'
                            ? <StatusBadge status={row[column.id]} />
                            : column.format
                              ? column.format(row[column.id], row)
                              : row[column.id]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Card>
        </Box>

        {/* Table Pagination outside the Card */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={sortedRequests.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count }) =>
              `Showing ${from}-${to} of ${count}`
            }
            sx={{
              borderTop: '1px solid rgba(224, 224, 224, 1)',
              '& .MuiTablePagination-selectLabel': {
                marginTop: '14px'
              },
              '& .MuiTablePagination-displayedRows': {
                marginTop: '14px'
              }
            }}
          />
        </Box>
      </Stack>

      <CustomFilter modalType={'drawer'} filterModal={filterModal} handleCloseModal={handleCloseFilterModal}>
        <Stack direction="column" alignItems="center" justifyContent="space-between" paddingY={2} paddingX={1} spacing={2}>
          <FormControl sx={{ flex: 1, minWidth: '100%' }}>
            <InputLabel id="source-label">Talep Firması</InputLabel>
            <Select
              labelId="source-label"
              id="source-label"
              name="source"
              value={filters.source}
              label="Talep Firması"
              onChange={handleFilterChange}
            >
              <MenuItem value="">Tümü</MenuItem>
              <MenuItem value="Kargolst">Kargolst</MenuItem>
              <MenuItem value="Vigo">Vigo</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ flex: 1, minWidth: '100%' }}>
            <InputLabel id="senderType-label">Gönderi Tipi</InputLabel>
            <Select
              labelId="senderType-label"
              id="senderType-label"
              name="senderType"
              value={filters.senderType}
              label="Gönderi Tipi"
              onChange={handleFilterChange}
            >
              <MenuItem value="">Tümü</MenuItem>
              <MenuItem value="Bireysel">Bireysel</MenuItem>
              <MenuItem value="Kurumsal">Kurumsal</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ flex: 1, minWidth: '100%' }}>
            <InputLabel id="type-label">Talep Türü</InputLabel>
            <Select
              labelId="type-label"
              id="type-label"
              name="type"
              value={filters.type}
              label="Talep Türü"
              onChange={handleFilterChange}
            >
              <MenuItem value="">Tümü</MenuItem>
              <MenuItem value="Kargo">Kargo</MenuItem>
              <MenuItem value="Kurye">Kurye</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label="Talep no ara..."
            variant="outlined"
            size="small"
            name="searchText"
            value={filters.searchText}
            onChange={handleFilterChange}
            sx={{ mt: 2 }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" paddingY={2} paddingX={1} spacing={2}>
          <ClearButton onClick={clearFilters} />
          <FilterButton onClick={applyFilters} />
        </Stack>
      </CustomFilter>

      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <IconButton sx={{ position: 'absolute', right: 16, top: 16 }} onClick={handleCloseModal}><span style={{ fontSize: 24 }}>&times;</span></IconButton>
        {modalOpen && editingRequest && renderForm()}
      </Dialog>
    </>
  );
}